'use client'

import React, { forwardRef } from 'react'
import './Button.css'

export type IconButtonVariant = 'default' | 'primary' | 'secondary' | 'outline' | 'ghost' | 'danger'
export type IconButtonSize = 'xs' | 'sm' | 'md' | 'lg'

export interface IconButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: string
  variant?: IconButtonVariant
  size?: IconButtonSize
  loading?: boolean
  tooltip?: string
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(({
  icon,
  variant = 'default',
  size = 'md',
  loading = false,
  tooltip,
  disabled,
  className = '',
  ...props
}, ref) => {
  const classes = [
    'ui-btn',
    'ui-btn--icon-only',
    `ui-btn--${variant}`,
    `ui-btn--${size}`,
    loading && 'ui-btn--loading',
    className
  ].filter(Boolean).join(' ')

  return (
    <button
      ref={ref}
      className={classes}
      disabled={disabled || loading}
      title={tooltip}
      {...props}
    >
      {loading ? (
        <i className="fa-solid fa-spinner fa-spin ui-btn__icon" />
      ) : (
        <i className={`${icon} ui-btn__icon`} />
      )}
    </button>
  )
})

IconButton.displayName = 'IconButton'

export default IconButton
